import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useButtonStyles = makeStyles((theme: Theme) =>
  createStyles({
    outlinedWhite: {
      color: "white",
      borderColor: "white",
      background: "transparent",
      "&:hover": {
        borderColor: "white",
        background: "transparent",
      },
    },
    containedWhite: {
      color: "black",
      borderColor: "white",
      backgroundColor: "white",
      "&:hover": {
        backgroundColor: "white",
        borderColor: "white",
      },
    },
    normalWidth: {
      minWidth: 185,
    },
    shortWidth: {
      minWidth: 120,
    },
  }),
);
